enum TableInstance {
  Customers = 'customers',
  Orders = 'orders',
  Products = 'products',
  Inventory = 'inventory',
  Atoms = 'atoms',
  FulfilmentProviders = 'fulfilment-providers',
  Queues = 'queues',
  FulfilmentOrders = 'fulfilment-orders',
  GoogleCalendarsAccounts = 'google-calendars-accounts',
  BookingsServices = 'bookings-services',
  PaymentProcessors = 'payment-processors',
  Payments = 'payments',
  ShippingProviders = 'shipping-providers',
  ShippingProfiles = 'shipping-profiles',
  AssignProductsAndVariants = 'assign-products-and-variants',
  AssignedProducts = 'assigned-products',
  ManageZones = 'manage-zones',
  Cities = 'cities',
  Packages = 'packages',
  Users = 'users',
}

export default TableInstance;
